import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Fortbildung } from '../fortbildung';
import { User } from '../../../../../src/app/administration/user/user';

@Component({
    selector: 'kiene-teilnehmer-hinzufuegen-dialog',
    templateUrl: './teilnehmer-hinzufuegen-dialog.component.html',
    styleUrls: ['./teilnehmer-hinzufuegen-dialog.component.scss'],
})
export class TeilnehmerHinzufuegenDialogComponent implements OnInit {
    fortbildung: Fortbildung;
    params = new HttpParams().set('mitarbeiter', '1');

    constructor(
        public dialogRef: MatDialogRef<TeilnehmerHinzufuegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        @Inject(API_BASE_URL_SERVICE) protected apiBaseUrl: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.fortbildung = this.data.fortbildung;
            if (!this.fortbildung.teilnehmer) {
                this.fortbildung.teilnehmer = [];
            }
        }
    }

    addTeilnehmer(selectedUser: User) {
        const exists = this.fortbildung.teilnehmer?.some((t: User) => t.benutzer_id === selectedUser.benutzer_id);

        if (!exists) {
            this.fortbildung.teilnehmer.push(selectedUser);
        }
    }

    removeTeilnehmer(teilnehmer: User) {
        // Fortbildung-Teilnehmer aktualisieren
        this.fortbildung.teilnehmer = this.fortbildung.teilnehmer.filter(
            (t: User) => t.benutzer_id != teilnehmer.benutzer_id,
        );
    }

    save(): void {
        this.api.post(this.apiBaseUrl + 'fortbildung/update.php', this.fortbildung).subscribe({
            next: response => {
                this.messageService.infoMessage('Die Fortbildung wurde erfolgreich gespeichert.');
                this.dialogRef.close(response);
            },
            error: error => {
                this.messageService.errorMessage('Die Fortbildung konnte nicht gespeichert werden.', error);
            },
        });
    }
}
